import axios from "axios";
import Cookies from "js-cookie";

export const mmHost = `http://3.7.85.13`;
export const host =   `http://3.7.85.13`;
export const companyId = 1;
export const locale = 'sv-SE';
export const devMode = false;

export const hostTimeZone = 5.5;

Date.prototype.getISOStringOfTimezone = function (timezone = hostTimeZone) {
  return new Date(timezone * 3600000 + this.getTime()).toISOString(); //slice(0, -1);
};

export const Logout = async (returnTo) => {
  let {data} = await axios.get(`${host}/logout?returnTo=${returnTo}`);
  Cookies.remove('uId');
  window.open(`${host}/${data.redirect}`, "_self");  
};

export const Authenticate = async (email, password) => {
  let res = await axios.post(`${host}/login`, {
    email,
    password,
    returnTo: "",
  });
  res = res.data;
  if (res.error_text == "Authentication Failure") {
    alert("Invalid Credentials");
    return false;
  }
  Cookies.set("uId", res.uId);
  return res;
};

export const plantInfo = (args) => {
  return `${mmHost}/plantInfo?${jsonToURL(args)}`;
};

export const getDowntimeReasons = (args) => {
  return `${host}/chartserver/downtimeReasons?${jsonToURL(args)}`;
};

export function jsonToURL(data) {
  let url = "";
  for (var key in data) {
    if (data.hasOwnProperty(key)) {
      if (data[key] !== "") {
        url = url + key + "=" + data[key] + "&";
      }
    }
  }
  url = url.substring(0, url.length - 1);
  return url;
}

export function getShiftDetils(plantCode, shiftCode, shiftDate) {
  return axios
    .get(
      plantInfo({
        i4Usage: true,
        plantCode: plantCode,
      })
    )
    .then(function ({ data }) {
      let shifts = data[0]["shifts"];
      let shiftDetails = {};
      for (var i = 0; i < shifts.length; i++) {
        shiftDetails[shifts[i]["shiftCode"]] = {
          startTime: shifts[i]["shiftStartTime"],
          endTime: shifts[i]["shiftEndTime"],
          startDateCorrection: shifts[i]["startDateCorrection"],
          endDateCorrection: shifts[i]["endDateCorrection"],
        };
      }

      if (shiftCode && shiftDate) {
        let shiftStartDateCorrectionFactor =
          shiftDetails[shiftCode]["startDateCorrection"];
        let shiftEndDateCorrectionFactor =
          shiftDetails[shiftCode]["endDateCorrection"];

        let shiftStartTime = new Date(
          new Date(
            shiftDate + "T" + shiftDetails[shiftCode]["startTime"] + ""
          ).getTime() +
            shiftStartDateCorrectionFactor * 86400000
        ).toISOString();
        let shiftEndTime = new Date(
          new Date(
            shiftDate + "T" + shiftDetails[shiftCode]["endTime"] + ""
          ).getTime() +
            shiftEndDateCorrectionFactor * 86400000
        ).toISOString();

        return { shiftStartTime, shiftEndTime };
      }else{
        let shiftStartTime = new Date(
          new Date(
            shiftDate + "T" + "00:00:00.000"
          ).getTime() +
            0 * 86400000
        ).toISOString();
        let shiftEndTime = new Date(
          new Date(
            shiftDate + "T" + "23:59:59.999"
          ).getTime() +
            0 * 86400000
        ).toISOString();
        return { shiftStartTime, shiftEndTime };
      }
    })
    .catch((e) => {
      console.error(e);
      return { shiftStartTime: "", shiftEndTime: "" };
    });
}

export function isIsoDate(str) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
  var d = new Date(str);
  return d.toISOString() === str;
}

export function isoToReadable(iso) {
  try {
    if (iso != null)
      return iso.split("T")[0] + " " + iso.split("T")[1].slice(0, -5);
  } catch (e) {
    console.error(iso, e);
    return iso;
  }
}

export function readableToiso(readable) {
  try {
    return readable.split(" ").join("T") + ".000Z";
  } catch (e) {
    console.error(readable, e);
    return readable;
  }
}

export async function queryDB(
  data,
  collection = "speedx",
  mode = "search",
  options = {}
) {
  let request = {};
  request.url = `${host}/chartserver/queryDB?collection=${collection}&mode=${mode}&uniqueKey=${options.uniqueKey}`;
  request.contentType = "application/json; charset=utf-8";
  request.dataType = "json";
  request.header = {'Content-Type': 'application/json'};
  request.data = JSON.stringify(data);
  if (options.uniqueKey) {
    request.type = "GET";
  } else {
    request.type = "POST";
  }

  let response = await fetch(request.url, {
    method: request.type,
    headers: request.header,
    body: request.data,
    //  credentials: 'include'
  });

  return response;

}


export function getStrokes(args) {
  return `${host}/machine/data?${jsonToURL(args)}`;
}

export function getUserInfo(userId){
  return `${host}/user/${userId}`;
}


export function msToHHMMSS(time_ms){
  let ms = time_ms%1000;
  time_ms = (time_ms - ms)/1000;

  let ss = time_ms%60;
  time_ms = (time_ms - ss)/60;

  let mm = time_ms%60;
  time_ms = (time_ms - mm)/60;

  let hh = time_ms%60;
  time_ms = (time_ms - hh)/60;

  return (`${prependZero(hh)}:${prependZero(mm)}:${prependZero(ss)}`)
}

function prependZero(number) {
  if (number < 10 && number > 0) {
      return "0" + number;
  } else if (number == 0) {
      return "00";
  } else {
      return number + "";
  }
}


export const typeConfigs = {
  stamping: {
      availParam: {
          key: "numStrokes",
          note: "Strokes",
          min: 0,
          max: 20
      },
      downtimeAbove:2
  },
  weld: {
      availParam: {
          key: "current",
          note: "Current",
          min: 0,
          max: 1000
      },
      downtimeAbove:2
  },
  cnc: {
      availParam: {
          key: "spindleRPM",
          note: "Spindle RPM",
          min: 0,
          max: 1000
      },
      downtimeAbove:2
  }
}